// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { withFormContainer } from './storybook-with-form';

// export validators
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	validateString,
	validateSelectField,
	validateCascadingSelectField,
	validateUserPickerField,
	validateCheckboxField,
	validateComponentField,
	validateCustomTeamsField,
	validateGroupPickerField,
	validateMultiVersionsField,
	validateOrganizationsField,
	validatePriorityField,
	validateRadioSelectField,
	validateRadioGroupField,
	validateResolutionField,
	validateSingleVersionField,
	validateLabelField,
} from './validators';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { closeMenuOnScroll, ISSUE_CREATE_MODAL_BODY_SELECTOR } from './select';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { handleApolloError } from './handle-apollo-error';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { preventFormSubmitOnEnterKeyPress } from './date';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transformProjectType } from './transform-project-type';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getValueFromEventOrValue } from './form';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transformStargateUrl, transformCreateIssueUrl } from './transform-stargate-url';

export const getFieldContainerId = (fieldId: string) => `${fieldId}-container`;
